import { render, staticRenderFns } from "./listFeedbackUser.vue?vue&type=template&id=23adb49a"
import script from "./listFeedbackUser.vue?vue&type=script&lang=js"
export * from "./listFeedbackUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports